module.exports = __webpack_public_path__ + "img/doctors_header.5525bf3d.jpg";